import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconList = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 18,
	viewBox: "0 0 16 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M0.125 3.34375C0.125 2.88672 0.476562 2.5 0.96875 2.5H15.0312C15.4883 2.5 15.875 2.88672 15.875 3.34375C15.875 3.83594 15.4883 4.1875 15.0312 4.1875H0.96875C0.476562 4.1875 0.125 3.83594 0.125 3.34375ZM0.125 8.96875C0.125 8.51172 0.476562 8.125 0.96875 8.125H15.0312C15.4883 8.125 15.875 8.51172 15.875 8.96875C15.875 9.46094 15.4883 9.8125 15.0312 9.8125H0.96875C0.476562 9.8125 0.125 9.46094 0.125 8.96875ZM15.875 14.5938C15.875 15.0859 15.4883 15.4375 15.0312 15.4375H0.96875C0.476562 15.4375 0.125 15.0859 0.125 14.5938C0.125 14.1367 0.476562 13.75 0.96875 13.75H15.0312C15.4883 13.75 15.875 14.1367 15.875 14.5938Z",
		fill: "#949494"
	})]
});
const ForwardRef = forwardRef(SvgIconList);
export { ForwardRef as ReactComponent };
